
export const ACTIONS = 'ACTIONS'
export const ALERTS = 'ACTIONS'
export const DAILYROUND_MESSAGES = 'DAILYROUND_MESSAGES'
export const DIAGNOSIS_FACTORY = 'DIAGNOSIS_FACTORY'
export const DIAGNOSIS_LINE = 'DIAGNOSIS_LINE'
export const DR = 'DR'
export const GEMBA_WALK = 'GEMBA_WALK'
export const FIVE_S = '5S'
export const ILUO = 'ILUO'
export const IMPROVEMENT_IDEA = 'IMPROVEMENT_IDEA'
export const LC = 'LC'
export const LPA = 'LPA'
export const MY_CALENDAR = 'MY_CALENDAR'
export const OBSERVATION = 'OBSERVATION'
export const OK_FIRST_PART = 'OK_FIRST_PART'
export const OVERVIEW = 'OVERVIEW'
export const PROBLEM_SOLVING = 'PS'
export const PRODUCTION_FORMAT = 'PRODUCTION_FORMAT'
export const PRODUCTION_HIERARCHY = 'PRODUCTION_HIERARCHY'
export const ROTATION_TABLE = 'ROTATION_TABLE'
export const STANDARD_WORK_REVIEW = 'STANDARD_WORK_REVIEW'
export const TASK_MANAGER = 'TASK_MANAGER'
export const TASK_MANAGER_ASSIGNMENT = 'TASK_MANAGER_ASSIGNMENT'
export const VS = 'VS'
export const VT = 'VT'
export const VT_RESULTS = 'VT_RESULTS'
export const HSE_RISK = 'HSE_RISK'

export const SHOP_FLOOR_MANAGEMENT = 'SHOP_FLOOR_MANAGEMENT'

export const LINE_BOARD = 'LINE_BOARD'
